<template>
  <div class="body1">
    <div class="content">
      <div class="title">THE BEST E-LEARNING SOLUTION FOR EFL KIDS</div>
      <img class="img" src="../../assets/body3-img.png">
      <div class="desc">★ Independent assessment conducted by Educational Support Systems (ESS), San Mateo, CA, Preliminary assessment results in California schools using Levels 0 &1, show marked success for ELL children using E-Blocks. Students used E-Blocks 15 minutes a day, 4 days each week.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>


<style scoped lang="less">
@import "../../assets/style/index";

.body1{
  height: 708px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url("../../assets/body3-bg.png") no-repeat;
  background-size: auto 100%;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    .title{
      font-size: 38px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 50px;
      margin-top: 30px;
    }
    .desc{
      margin-top: 36px;
      margin-bottom: 56px;
      text-align: center;
      font-size: 18px;
      line-height: 30px;
      font-family: 'ArialMT', Helvetica, Arial, sans-serif;
    }
    .img{
      width: 90%;
      object-fit: contain;
      height: 414px;
      margin-top: 40px;
      margin-bottom: 39px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/e-body3.vue